module.exports = __webpack_public_path__ + "img/1F1FB-1F1EC.0813433f.svg";